/**
 * The New York Times coverage, Oct 14 2026 (Erin Griffith, tech section). ONE source for every
 * surface that mentions it (Nitish, Oct 14 2026: "Featured in The New York Times" on home, up front).
 *
 * Legal (Nora, CEL-3450): the text line and short attributed quotes are cleared; NO NYT logo or
 * NYT lettering without the Times' written permission; never repeat the article's headcount line.
 * The quote below is the cleared one, verbatim from the article.
 */
export const NYT_FEATURE = {
  url: 'https://www.nytimes.com/2026/10/14/technology/ai-agents-communication-tech-dinner-party.html',
  lead: 'Featured in The New York Times',
  quote: '\u201cCellCog helps other companies hire A.I. employees.\u201d',
  cta: 'Read the story',
  /* Trust-row tile (first of three, home + /ai-employees). The line is OUR description of the
     article, never in quotation marks (Nitish, Oct 14 2026: "I agree with the second line"). */
  tileTitle: 'Featured in The New York Times',
  tileLine: 'How CellCog\u2019s AI employees work. October 2026.',
};
